import { put, select, takeLatest } from 'redux-saga/effects'
import { isNil } from 'ramda'
import { getVehicleServiceRecordDate } from 'selectors/truck'
import {
  HAS_SERVICE_RECORD_DATE,
  SET_SERVICE_RECORD_MODAL,
} from 'actions/truck'

export default function* watchHasServiceRecordDate() {
  yield takeLatest(HAS_SERVICE_RECORD_DATE, hasServiceRecordDate)
}

function* hasServiceRecordDate(action) {
  if (isNil(action)) return

  const {
    payload: { serialNumber, cancelHandler },
  } = action
  const serviceDate = yield select((state) =>
    getVehicleServiceRecordDate(state, serialNumber)
  )

  if (isNil(serviceDate)) {
    yield put({
      type: SET_SERVICE_RECORD_MODAL,
      payload: { visible: true, cancelHandler },
    })
  }
}
